import React, { Component } from 'react'
import moment from 'moment'

import { TIMING_OPTIONS } from 'business/direct_quote_request/constants'
import RadioBordered from 'tailwind/common/components/form/RadioBordered'
import DatePicker from 'tailwind/common/components/DatePicker'

class Timeline extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.timingPreference !== 'on_a_particular_date' &&
      this.props.timingPreference === 'on_a_particular_date'
    ) {
      this.scrollDatePickerIntoView()
    }
  }

  scrollDatePickerIntoView = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (!this.datePickerSectionEl) return

        this.datePickerSectionEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        setTimeout(() => {
          this.focusDateInput()
        }, 500)
      })
    })
  }

  focusDateInput = () => {
    if (!this.datePickerSectionEl) return

    const input = this.datePickerSectionEl.querySelector('input')
    if (input) {
      input.focus({ preventScroll: true })
    }
  }

  setDatePickerSectionRef = (el) => {
    this.datePickerSectionEl = el
  }

  parseScheduleDate = (scheduleDate) => {
    if (!scheduleDate) return null

    const parsed = moment(scheduleDate, 'DD/MM/YYYY', true)
    return parsed.isValid() ? parsed.toDate() : null
  }

  handleDateChange = (date) => {
    const formattedDate = date ? moment(date).format('DD/MM/YYYY') : ''
    this.props.onFieldChange('scheduleDate', formattedDate)
  }

  render() {
    const { timingPreference, scheduleDate, businessName, onFieldChange } = this.props
    const businessNameLabel = businessName || 'this business'

    return (
      <div className="flex flex-col gap-5 lg:gap-6">
        <div className="flex flex-col gap-1">
          <p className="text-base font-extrabold text-base-gray-text-main">
            When do you need the job completed?
          </p>
          <p className="text-sm font-medium text-base-gray-text-main">
            Select your preferred timeframe to help {businessNameLabel} plan and price accurately.
          </p>

          <div className="pt-2 space-y-3">
            {TIMING_OPTIONS.map((option) => {
              const isChecked = timingPreference === option.value
              return (
                <div key={option.value} className="w-full">
                  <RadioBordered
                    id={`dqr-timeline-${option.value}`}
                    value={option.value}
                    fieldName="timingPreference"
                    label={option.label}
                    isChecked={isChecked}
                    hasErrors={false}
                    onChangeHandler={() => onFieldChange('timingPreference', option.value)}
                    labelClassName="text-sm font-medium"
                    align="center"
                    checkedBorderClassName="border-3.0 border-base-blue-main"
                    className="w-full h-14 flex"
                  />
                </div>
              )
            })}
          </div>
        </div>

        {timingPreference === 'on_a_particular_date' && (
          <div ref={this.setDatePickerSectionRef} className="flex flex-col gap-1">
            <label className="block text-base font-extrabold text-base-gray-text-main" htmlFor="dqr-schedule-date">
              Best date for work?
            </label>
            <div className="pt-2">
              <DatePicker
                id="dqr-schedule-date"
                fieldName="scheduleDate"
                defaultDate={this.parseScheduleDate(scheduleDate)}
                handleDateChange={this.handleDateChange}
                orientation="top"
                placeholder="What day?"
                inputClass="text-sm font-normal"
                minDate={moment().add(1, 'day').toDate()}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Timeline
